import script from "./AccountLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountLinks.vue?vue&type=script&setup=true&lang=js"

import "./AccountLinks.vue?vue&type=style&index=0&id=60a949cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a949cb"]])

export default __exports__